import { render, staticRenderFns } from "./confirmExam.vue?vue&type=template&id=0c795d7e&scoped=true&"
import script from "./confirmExam.vue?vue&type=script&lang=js&"
export * from "./confirmExam.vue?vue&type=script&lang=js&"
import style0 from "./confirmExam.vue?vue&type=style&index=0&id=0c795d7e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c795d7e",
  null
  
)

export default component.exports